export const RAW_MATERIALS = {
  HOME: 'campaign-home',
  IMPACT: 'campaign-impact',
  ARTICLE: 'campaign-article',
  METAL: 'campaign-metal',
  METAL_DETAIL: 'campaign-metal-detail',
  CONTENT_GALLERY: 'campaign-content-gallery',
  TAKE_ACTIONS: 'campaign-take-action',
} as const
